import { render } from "./AddStore.vue?vue&type=template&id=555e87e6&scoped=true"
import script from "./AddStore.vue?vue&type=script&lang=js"
export * from "./AddStore.vue?vue&type=script&lang=js"

import "./AddStore.vue?vue&type=style&index=0&id=555e87e6&scoped=true&lang=css"

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555e87e6"]])

export default __exports__